import React, { useState } from 'react';
import { Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import cookieManager from '../../utils/cookieManager';
import CookiePreferencesFields from '../common/CookiePreferencesFields';
import CookieSettingsDialogChrome from '../common/CookieSettingsDialogChrome';

/**
 * Component for managing cookie preferences
 * Can be placed in footer or other accessible locations
 */
const CookiePreferencesManager = ({ buttonVariant = 'text', buttonSize = 'small', buttonColor = 'inherit', sx = {} }) => {
  const [open, setOpen] = useState(false);
  const [preferences, setPreferences] = useState(cookieManager.getCookiePreferences());
  const navigate = useNavigate();

  const handleOpen = () => {
    setPreferences(cookieManager.getCookiePreferences());
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    cookieManager.saveCookiePreferences(preferences);
    setOpen(false);
  };

  const handleViewPolicy = () => {
    navigate('/privacy-policy');
    setOpen(false);
  };

  const handlePreferenceChange = (event) => {
    setPreferences({
      ...preferences,
      [event.target.name]: event.target.checked
    });
  };

  const handleResetPreferences = () => {
    cookieManager.resetCookiePreferences();
    window.location.reload();
  };

  return (
    <>
      <Button
        variant={buttonVariant}
        size={buttonSize}
        color={buttonColor}
        onClick={handleOpen}
        sx={sx}
      >
        Cookie Settings
      </Button>

      <CookieSettingsDialogChrome
        open={open}
        onClose={handleClose}
        titleId="cookie-preferences-manager-dialog"
        onViewPolicy={handleViewPolicy}
        onSave={handleSave}
      >
        <CookiePreferencesFields
          preferences={preferences}
          onPreferenceChange={handlePreferenceChange}
        />
        <Box sx={{ mt: 2 }}>
          <Button
            size="small"
            color="secondary"
            onClick={handleResetPreferences}
          >
            Reset All Settings
          </Button>
        </Box>
      </CookieSettingsDialogChrome>
    </>
  );
};

export default CookiePreferencesManager;
